import dentalblog from './../../../assets/images/blogs/dentalblog.jpg';
import prpblog from './../../../assets/images/blogs/prp blog-21-07-2025.jpg';
import gfcblog from './../../../assets/images/blogs/gfc blog 21-07-25.webp';
import growhair from './../../../assets/images/blogs/growhair1-31-07-2025.jpg';
import glowingskin from './../../../assets/images/blogs/glowingskin-12-08-2025.jpg';

import corporateImg from './../../../assets/images/dentalcleaning.jpeg'
import HydraFacial from './../../../assets/images/blogs/HydraFacial blog 22-09-25.webp';
import GfcVsPrp from './../../../assets/images/blogs/Hcura-gfc-vs-prp-15-10-2025.jpg';
import stm from './../../../assets/images/blogs/STM Hair growth treatment-17-10-2025.webp';
import gfchairgrowth from './../../../assets/images/blogs/GFC hair growth treatment-18-10-2025.jpg';
import laserhair from './../../../assets/images/blogs/laserhair-20-10-2025.png';
import gfcbanglore from './../../../assets/images/blogs/GfcBangalore_20-10-2025.jpeg';
import gfcchennai from './../../../assets/images/blogs/gfcchennaiblog30-10-2025.jpg';
import prpblog2 from './../../../assets/images/blogs/prp_blog_15-11-2025.jpg';


const blogData = [
  {
    slug: "/prp-hair-treatment-rapid-hair-regrowth-2025",
    title: "PRP Hair Treatment at H-Cura Multispeciality Clinic: The Best Clinic for Rapid Hair Regrowth in 2025",
    image: prpblog2,
    date: "Nov 15, 2025",
    content: "Experience advanced PRP Hair Treatment at H-Cura Multispeciality Clinic for rapid hair regrowth, reduced hair fall, and natural hair restoration. Our expert PRP therapy ensures fast results, thicker hair density, and the best hair regrowth solution in 2025."
  },

   {
    slug: "/best-gfc-hair-regrowth-treatment-chennai",
    title: "Best GFC Hair Regrowth Treatment in Chennai | H-Cura Clinic",
    image: gfcchennai,
    date: "Nov 06, 2025",
    content: "Get the best GFC Hair Regrowth Treatment in Chennai at H-Cura Clinic. Our advanced growth factor therapy helps restore natural hair growth and reduce hair fall effectively. #GFCHairTreatment #HairRegrowth #HealthyHair #HairCare"
  },
  // {
  //   slug: "/laser-hair-therapy-hair-regrowth",
  //   title: "Laser Hair Therapy: A Game-Changer in Hair Regrowth",
  //   image: laserhair,
  //   date: "Oct 20, 2025",
  //   content: "Laser Hair Therapy stimulates hair follicles using low-level laser light, promoting natural growth and reducing hair thinning. It’s a safe, non-invasive solution for achieving stronger, thicker hair."
  // },
    {
    slug: "/best-gfc-hair-regrowth-treatment-in-bangalore",
    title: "Best GFC Hair Regrowth Treatment in Bangalore | H-Cura Clinic",
    image: gfcbanglore,
    date: "Oct 20, 2025",
    content: "H-Cura Clinic offers the best GFC Hair Regrowth Treatment in Bangalore, designed to boost natural hair growth and thickness. Experience visible results with safe, advanced, and effective GFC therapy. #GFCHairTreatment #HairRegrowth #HealthyHair #HairCare"
  },
   {
    slug: "/how-many-gfc-sessions-for-hair-regrowth",
    title: "How Many GFC Sessions Are Needed for Visible Hair Regrowth?",
    image: gfchairgrowth,
    date: "Oct 18, 2025",
    content: "Most people see visible regrowth after 3–4 monthly GFC sessions. Individual results depend on how advanced the hair loss and scalp health are. #GFCHairTreatment #HairRegrowth #HealthyHair #HairCare"
  },
  {
    slug: "/stm-hair-treatment-for-hair-growth",
    title: "STM Hair Treatment and How It Works for Hair Growth (2025 Guide)",
    image: stm,
    date: "Oct 17, 2025",
    content: "STM Hair Treatment promotes natural hair growth by stimulating inactive follicles. It’s an advanced 2025 method for achieving thicker and healthier hair. #STMHairTreatment #HairGrowth #HealthyHair #HairCare"
  },

  {
    slug: "/gfc-vs-prp-hair-treatment",
    title: "GFC vs PRP Hair Treatment – Which Works Better for Hair Regrowth in 2025?",
    image: GfcVsPrp,
    date: "Oct 14, 2025",
    content: "GFC or PRP — which really gives faster hair regrowth in 2025? The truth might surprise you, Still confused between PRP and GFC? Find out what experts are saying. #HairRegrowth #GFCvsPRP #HairLossTreatment #HealthyHair"
  },

  {
    slug: "/hydrafacial-dull-to-dazzling-restore-radiance",
    title: " HydraFacial: From Dull to Dazzling – How HydraFacial Restores Radiance",
    image: HydraFacial,
    date: "Sep 22, 2025",
    content: "HydraFacial deeply cleanses, exfoliates, and hydrates to restore your natural glow. It reduces dullness, unclogs pores, and leaves your skin radiant and healthy.#HydraFacial #GlowingSkin #RadiantSkin #SkinCare "
  },
   {
    slug: "/glowing-skin-treatment",
    title: " Simple Daily Habits to Maintain Clear Skin: Your Guide to a Glowing, Confident Look",
    image: glowingskin,
    date: "Aug 12, 2025",
    content: "Achieve clear, glowing skin with simple daily habits and natural skincare tips. Maintain a healthy, radiant look effortlessly.#ClearSkin #GlowingSkin #SkincareTips #HealthySkin #BeautyCare "
  },
   {
    slug: "/growhair-therapy-hair-fall-treatment",
    title: " GrowHair Therapy: Advanced Hair Fall Treatment That Delivers Visible Regrowth",
    image: growhair,
    date: "July 31, 2025",
    content: "Experience visible hair regrowth with GrowHair Therapy – the advanced solution for thinning hair, hair fall control, and scalp rejuvenation. Ideal for both men and women.#HairRegrowth #HairFallTreatment #ScalpCare"
  },
  {
    slug: "/gfc-hair-treatment-vs-traditional-methods-bangalore-chennai",
    title: "GFC Hair Treatment Vs. Traditional Methods: Which Is Right for You?",
    image: gfcblog,
    date: "July 22, 2025",
    content: "Discover the difference between GFC Hair Treatment and traditional hair loss solutions to choose the best option for your hair regrowth journey. Explore benefits, results, and expert insights.#GFCHairTreatment #HairLossSolutions #HairRegrowth #HealthyHair #PRPAlternative"
  },
     {
    slug: "/avoid-cavities-best-dental-clinic",
    title: "Daily Habits to Prevent Cavities : Your Guide to a Healthier Smile",
    image: dentalblog,
    date: "July 21, 2025",
    content: "Maintain a confident, cavity-free smile by adopting daily oral hygiene practices. From brushing twice a day to limiting sugary snacks, these small habits can prevent major dental issues in the long run"
  },
  {
    slug: "/prp-hair-growth-therapy-scalp-fertilizer",
    title: "If Your Scalp Was a Garden, PRP Is the Fertilizer: Your Path to Healthier Hair Growth",
    image: prpblog,
    date: "July 18, 2025",
    content: "PRP hair treatment nourishes your scalp like a fertilizer, stimulating natural hair regrowth and strength.Boost hair volume with this safe, non-surgical #HairLossSolution. #PRPHairTreatment #HealthyHairGrowth"
  },
 
];

export default blogData;
